export const SuccessStatusesEnum = {
    Cashout: 0,
    CashoutFailed: 1,
    CashoutBet: 2,
    CashoutBetFailed: 3,
    EarlyCashoutSucceed: 4,
    Cashin: 5,
    CashinFailed: 6,
    SuperBetAccepted: 7,
    SuperBetRejected: 8,
    BetNotFound: 9,
    CashoutWithFeeSucceed: 10,
    CashoutSucceed: 11,
    DepositToClientAccountSucceed: 12
};